import React from 'react';
import Layout from '../components/Layout/Layout';
import mapPdf from '../images/BUILDINGMAP.pdf';
import landPdf from '../images/LANDDETAILS.pdf';

const InfrastructurePage = () => {
  return (
    <Layout>
      <div id="infrastructure" className="page-container" style={{ maxWidth: '800px', fontSize: '0.90rem', margin: '40px auto', padding: '0 20px', minHeight: '300px' }}>
        <div id="building-map" style={{ marginBottom: '40px' }}>
          <h2 style={{ color: 'var(--primary-blue)', borderBottom: '2px solid var(--light-blue)', paddingBottom: '10px', marginBottom: '20px' }}>
            Building Map
          </h2>
          <div style={{ backgroundColor: '#fff', padding: '30px', borderRadius: '8px', boxShadow: '0 2px 10px rgba(0,0,0,0.05)', textAlign: 'center' }}>
            <p style={{ color: '#555', marginBottom: '20px' }}>Layout of our college building.</p>
            <iframe src={mapPdf} width="100%" height="800px" title="Building Map" style={{ border: 'none', backgroundColor: '#f0f0f0' }} />
          </div>
        </div>

        <div id="land-details">
          <h2 style={{ color: 'var(--primary-blue)', borderBottom: '2px solid var(--light-blue)', paddingBottom: '10px', marginBottom: '20px' }}>
            Land Documents
          </h2>
          <div style={{ backgroundColor: '#fff', padding: '30px', borderRadius: '8px', boxShadow: '0 2px 10px rgba(0,0,0,0.05)', textAlign: 'center' }}>
            <p style={{ color: '#555', marginBottom: '20px' }}>View official land usage and title documents.</p>
            <iframe src={landPdf} width="100%" height="800px" title="Land Documents" style={{ border: 'none', backgroundColor: '#f0f0f0' }} />
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default InfrastructurePage;
